export const ExternalLinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="18"
      viewBox="0 96 960 960"
      width="16"
      style={{
        marginTop: '4px',
      }}
    >
      <path
        d="M243 834.653 173.347 765l391.999-391.999H226.999v-98.002h506.002v506.002h-98.002V442.654L243 834.653Z"
        fill="currentColor"
      />
    </svg>
  );
};
